import { render, staticRenderFns } from "./Junior.vue?vue&type=template&id=42da1748&scoped=true&"
import script from "./Junior.vue?vue&type=script&lang=js&"
export * from "./Junior.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42da1748",
  null
  
)

export default component.exports